<template>
  <div>
    <div class="page-header"><h2><span class="breadcrumb-level">订单管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">订单列表</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">宠境酒店订单</span></h2><div class="header-actions">
      <el-select v-model="filterStatus" placeholder="订单状态" clearable style="width:130px" @change="fetchData">
        <el-option label="待付款" value="pending" /><el-option label="待服务" value="paid" />
        <el-option label="服务中" value="in_service" /><el-option label="已完成" value="completed" />
        <el-option label="已取消" value="cancelled" />
      </el-select>
      <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="YYYY-MM-DD" style="width:250px" @change="fetchData" />
      <el-input v-model="phoneQuery" placeholder="手机号" clearable prefix-icon="Phone" style="width:160px" @input="fetchData" />
      <el-input v-model="searchQuery" placeholder="订单号" clearable prefix-icon="Search" style="width:160px" @input="fetchData"/>
    </div></div>
    <el-table :data="orders" stripe v-loading="loading">
      <el-table-column label="订单号" prop="order_no" width="160"/>
      <el-table-column label="商品" min-width="150"><template #default="{row}">{{row.items?.[0]?.product_name||'-'}}</template></el-table-column>
      <el-table-column label="用户" width="120"><template #default="{row}">{{row.user?.name||row.contact_name||'-'}}</template></el-table-column>
      <el-table-column label="手机号" width="130"><template #default="{row}">{{row.user?.phone||row.contact_phone||'-'}}</template></el-table-column>
      <el-table-column label="金额" width="110"><template #default="{row}">¥{{Number(row.total_amount).toLocaleString()}}</template></el-table-column>
      <el-table-column label="状态" width="90"><template #default="{row}"><el-tag :type="statusType(row.status)" size="small">{{statusLabel(row.status)}}</el-tag></template></el-table-column>
      <el-table-column label="时间" width="150"><template #default="{row}">{{formatDateTime(row.created_at)}}</template></el-table-column>
      <el-table-column label="服务人员" width="150"><template #default="{row}">{{row.verify_clerk_snapshot?.name||'-'}} {{row.verify_clerk_snapshot?.phone||''}}</template></el-table-column>
      <el-table-column label="操作" width="130" fixed="right"><template #default="{row}">
        <el-button type="primary" link size="small" @click="handleDetail(row.id)">详情</el-button>
        <el-button type="danger" link size="small" @click="openCancelDialog(row)" v-if="row.status==='paid'">取消</el-button>
      </template></el-table-column>
    </el-table>

    <el-pagination
      v-if="pagination.total > 0"
      v-model:current-page="pagination.current_page"
      v-model:page-size="pagination.per_page"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10,20,50]"
      small
      background
      style="margin-top:16px;justify-content:flex-end"
      @current-change="fetchData"
      @size-change="fetchData"
    />

    <el-dialog v-model="detailVisible" title="订单详情" width="700px" destroy-on-close>
      <template v-if="detail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="订单号" :span="2">{{ detail.order_no }}</el-descriptions-item>
          <el-descriptions-item label="订单类型">{{ orderTypeLabel(detail.order_type) }}</el-descriptions-item>
          <el-descriptions-item label="状态"><el-tag :type="statusType(detail.status)" size="small">{{statusLabel(detail.status)}}</el-tag></el-descriptions-item>
          <el-descriptions-item label="联系人">{{ detail.contact_name||'-' }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ detail.contact_phone||'-' }}</el-descriptions-item>
          <el-descriptions-item label="支付方式">{{ paymentMethodLabel(detail.payment_method) }}</el-descriptions-item>
          <el-descriptions-item label="支付状态">{{ paymentStatusLabel(detail.payment_status) }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{ formatDateTime(detail.created_at) }}</el-descriptions-item>
          <el-descriptions-item label="支付时间">{{ formatDateTime(detail.paid_at) }}</el-descriptions-item>
          <el-descriptions-item label="总金额">¥{{ Number(detail.total_amount).toLocaleString() }}</el-descriptions-item>
          <el-descriptions-item label="实付金额">¥{{ Number(detail.cash_amount||detail.total_amount).toLocaleString() }}</el-descriptions-item>
          <el-descriptions-item label="优惠金额" v-if="detail.discount_amount">¥{{ Number(detail.discount_amount).toLocaleString() }}</el-descriptions-item>
          <el-descriptions-item label="用户">{{ detail.user?.name||'-' }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ detail.remarks||'-' }}</el-descriptions-item>
        </el-descriptions>

        <el-divider />
        <h4 style="margin:0 0 12px">商品明细</h4>
        <el-table :data="detail.items" stripe size="small">
          <el-table-column label="商品名称" prop="product_name" min-width="140"/>
          <el-table-column label="规格" width="100"><template #default="{row}">{{row.specs||'-'}}</template></el-table-column>
          <el-table-column label="数量" width="60" prop="quantity"/>
          <el-table-column label="单价" width="80"><template #default="{row}">¥{{Number(row.unit_price).toLocaleString()}}</template></el-table-column>
          <el-table-column label="小计" width="80"><template #default="{row}">¥{{Number(row.subtotal).toLocaleString()}}</template></el-table-column>
        </el-table>
      </template>
    </el-dialog>

    <!-- 取消订单弹窗 -->
    <el-dialog v-model="cancelVisible" title="取消订单" width="450px" destroy-on-close>
      <el-form label-width="100px">
        <el-form-item label="订单编号">
          <span>{{ cancelOrder?.order_no }}</span>
        </el-form-item>
        <el-form-item label="用户">
          <span>{{ cancelOrder?.user?.name || cancelOrder?.contact_name || '-' }}</span>
        </el-form-item>
        <el-form-item label="实付金额">
          <span>¥{{ Number(cancelOrder?.cash_amount || cancelOrder?.total_amount || 0).toLocaleString() }}</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="cancelVisible=false">关闭</el-button>
        <el-button type="danger" :loading="cancelLoading" @click="handleCancel">确认取消并退款</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue';import * as api from '../../api/orders';
const searchQuery=ref('');const phoneQuery=ref('');const orders=ref([]);const loading=ref(false);
const filterStatus=ref('');const dateRange=ref(null);
const pagination = reactive({ current_page: 1, per_page: 20, total: 0, last_page: 1 });
const detailVisible=ref(false);const detail=ref(null);
const cancelVisible=ref(false);const cancelLoading=ref(false);const cancelOrder=ref(null);
const fetchData=async()=>{loading.value=true;try{const params={page:pagination.current_page,per_page:pagination.per_page};if(searchQuery.value)params.keyword=searchQuery.value;if(phoneQuery.value)params.phone=phoneQuery.value;if(filterStatus.value)params.status=filterStatus.value;if(dateRange.value){params.date_from=dateRange.value[0];params.date_to=dateRange.value[1]}const r=await api.getHotelOrders(params);orders.value=r.data||[];pagination.current_page=r.pagination?.current_page||1;pagination.total=r.pagination?.total||0}catch{}finally{loading.value=false}};
const handleDetail=async(id)=>{const r=await api.getOrderDetail(id);detail.value=r.data;detailVisible.value=true};
const openCancelDialog=(row)=>{cancelOrder.value=row;cancelVisible.value=true};
const handleCancel=async()=>{cancelLoading.value=true;try{await api.cancelOrder(cancelOrder.value.id);ElMessage.success('已取消并退款');cancelVisible.value=false;fetchData()}catch(e){ElMessage.error(e.response?.data?.message||'取消失败')}finally{cancelLoading.value=false}};
const formatDateTime=(v)=>{if(!v)return'-';const d=new Date(v);if(isNaN(d.getTime()))return v;return d.toLocaleString('zh-CN',{year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'})};
const statusLabel=(s)=>{const m={pending:'待付款',paid:'待服务',in_service:'服务中',completed:'已完成',cancelled:'已取消'};return m[s]||s||'-'};
const statusType=(s)=>{const m={completed:'success',cancelled:'danger',refunded:'danger',pending:'warning',in_service:'warning'};return m[s]||'info'};
const orderTypeLabel=(s)=>{const m={hotel:'宠境酒店',park:'宠境乐园',daycare:'日托',mall:'商城',activity:'活动报名',recharge:'余额充值'};return m[s]||s||'-'};
const paymentStatusLabel=(s)=>{const m={unpaid:'未支付',paid:'已支付',refunded:'已退款'};return m[s]||s||'-'};
const paymentMethodLabel=(s)=>{const m={wechat:'微信支付',balance:'余额支付',mixed:'混合支付',cash:'现金',points:'积分'};return m[s]||s||'-'};
onMounted(fetchData);
</script>
<style scoped>
.header-actions{display:flex;gap:12px;align-items:center}
</style>